<template>
<div>
  <div class="wrapper">
      <div class="content" >
           <div v-if="wish">{{wish.role_name}}的愿望是</div>
           <div v-if="wish">{{wish.desire}}</div>
            <div v-if="wish">{{wish.remark}}</div>
      </div>
      <div class="button-wrapper">
          <img src="../../assets/modal/confirm4.png" alt="" class="button"  @click="$emit('wishRandom-check')" >
      </div>
      
  </div>
</div>
</template>

<script>
import * as api from '@/api/index'
export default {
    name: 'wishRandom',
    data() {
        return {
            wish: null
        }
    },
    props: ["wishData", "currentCom"],
    watch: {
        currentCom(v) {
            v && this.randomWish()
        }
    },
    mounted() {
        this.randomWish()
    },
    methods: {
       async randomWish() {
            const res = await api.wishRandom({
                activity_id: this.wishData.activity_id
            })
                .catch(err => {

                })
            if (res) {
                const index = Math.floor(Math.random() * (res.length - 1))
                this.wish = res[index] || null
                console.log(this.wish, index, res)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 93.24vw;
    margin: 0 auto;
    margin-top: 14vw;
    min-height: 69.26vw;
    background-image: url("../../assets/modal/check.png");
    background-size: 100% 100%;
    overflow: hidden;
    .content {
        margin: 24vw auto 0;
        width: 70%;
        text-align: center;
        min-height: 20vw;
        font-size: 20px;
    }
    .button-wrapper {
        display: flex;
        justify-content: center;
         align-items: center;
    }
    .button {
        width: 30vw;
        margin: 2vw 2vw;
        display: block;
        flex-shrink: 0;
    }
}

</style>